export const TOGGLE_SNUG_FIT = "TOGGLE_SNUG_FIT";

export function toggleSnugFit(value) {
    return {
        type: TOGGLE_SNUG_FIT,
        value: value
    };
}
